module.exports = "<footer class=\"footer-section\">\n  <div class=\"container\">\n    <div class=\"row\">\n      <div class=\"col-lg-12 col-md-12 col-sm-12 col-xs-12\">\n        <div class=\"copyright text-center\">&copy; 2024 Jobble. All Rights Reserved</div>\n      </div>\n    </div>\n  </div>\n</footer>\n"


//////////////////
// WEBPACK FOOTER
// ./client/app/common/jobblefooter/jobblefooter.html
// module id = 23
// module chunks = 0